export default __webpack_public_path__ + "static/media/ThinkCACS.10b3ba6fc7665eb213cc83933c93032d.webp";